import React, { useEffect, useRef } from "react"
import { pingServer } from "services/users/calls"

const PING_INTERVAL = 30 * 1000

const PingActivity = props => {
  const intervalRef = useRef(null)

  const startPing = () => {
    stopPing()
    ;(async () => {
      try {
        await pingServer(window.location.pathname)
      } catch (error) {
        console.error("Erro ao pingar servidor:", error)
      }
    })()
    intervalRef.current = setInterval(async () => {
      try {
        await pingServer(window.location.pathname)
      } catch (error) {
        console.error("Erro ao pingar servidor:", error)
      }
    }, PING_INTERVAL)
  }

  const stopPing = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      startPing()
    } else {
      stopPing()
    }
  }

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange)

    if (document.visibilityState === "visible") {
      startPing()
    }

    return () => {
      stopPing()
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  return undefined
}

PingActivity.propTypes = {}

export default PingActivity
